/* eslint-disable react/prop-types */
import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import {
  TextField,
  Button,
  Typography,
  Box,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { addSnackbar } from '../../redux/reducers/ducks/SnackbarDuck';
import {
  addDisplayScreensApi,
  deleteDisplayScreenApi
} from '../../api/displayscreens/displayScreenApi';

const AddEditDisplayScreen = ({
  addDisplayScreenPopup,
  setAddDisplayScreenPopup,
  callFunc
}) => {
  const dispatch = useDispatch();

  const { register, handleSubmit, reset } = useForm({
    defaultValues: {}
  });

  useEffect(() => {
    if (addDisplayScreenPopup.id) {
      reset();
    }
  }, [addDisplayScreenPopup.isOpen]);

  const onSubmit = async (data) => {
    const res = await addDisplayScreensApi(data);
    if (res.status == 200) {
      dispatch(
        addSnackbar({
          message: 'New Display Screen Created',
          type: 'success'
        })
      );
      handleClose();
      callFunc();
    }
  };

  const handleClose = () => {
    setAddDisplayScreenPopup({ isOpen: false });
    reset();
  };

  return (
    <Box>
      <Container>
        <Dialog open={addDisplayScreenPopup.isOpen} onClose={handleClose}>
          <Box
            sx={{
              textAlign: 'center',
              width: 'min(100% -30px, 700px)',
              marginInline: 'auto'
            }}>
            <DialogTitle id="alert-dialog-title">
              {addDisplayScreenPopup.id ? (
                <Typography color="#FFA500" fontWeight="700">
                  Delete Display Screen
                </Typography>
              ) : (
                <Typography color="#FFA500" fontWeight="700">
                  Add New Display Screen
                </Typography>
              )}
            </DialogTitle>
            {!addDisplayScreenPopup.id ? (
              <DialogContent>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <TextField
                    {...register('name', { required: true })}
                    margin="normal"
                    label="Display Screen Name"
                    fullWidth
                  />
                  <TextField
                    {...register('desc', { required: true })}
                    margin="normal"
                    label="Description"
                    fullWidth
                  />
                  <Button variant="contained" color="primary" type="submit">
                    Submit
                  </Button>
                </form>
              </DialogContent>
            ) : (
              <>
                <DialogContent>
                  Are you sure to delete this Display Screen?
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleClose} autoFocus>
                    cancel
                  </Button>
                  <Button
                    onClick={async () => {
                      const res = await deleteDisplayScreenApi(
                        addDisplayScreenPopup?.id
                      );
                      if (res.status == 200) {
                        dispatch(
                          addSnackbar({
                            message: 'Display Screen Deleted',
                            type: 'warning'
                          })
                        );
                        handleClose();
                        callFunc();
                      }
                    }}>
                    Delete
                  </Button>
                </DialogActions>
              </>
            )}
          </Box>
        </Dialog>
      </Container>
    </Box>
  );
};

export default AddEditDisplayScreen;
